export default __webpack_public_path__ + "static/media/ogone.318238a0.jpg";